import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone';
import moment from 'moment';
import {
  CommonDialog,
  CommonPanel,
  DataTable,
} from 'components';
import {
  IconButton,
} from '@material-ui/core';
import {
  Close as CloseIcon,
  Search as DefaultIcon,
} from '@material-ui/icons';
import api from 'utils/api';
import { toast } from 'utils/helpers';
import DocumentViewer from '../ModelViewer/DocumentViewer';

const ValueImporter = props => {
  const [activeDocument, setActiveDocument] = useState(null);
  const { t } = useTranslation();

  return (
    <CommonDialog
      visible
      onClose={props.onClose}
      maxWidth="xl"
      style={{ position: 'relative', padding: 0 }}
    // title={props.title}
    >
      <div>
        {!activeDocument && (
          <div style={{ padding: 10 }}>
            <DocumentManager
              onDocumentSelect={(document) => setActiveDocument(document)}
            />
          </div>
        )}

        {!!activeDocument && (
          <DocumentViewer
            documentIds={[activeDocument._id]}
            onClose={() => setActiveDocument(null)}
            onValueSelect={(value) => props.onValueSelect(value)}
            selectOnlyNumbers={props.selectOnlyNumbers}
          />
        )}
      </div>

    </CommonDialog>
  )
}

const DocumentManager = ({ onDocumentSelect }) => {
  const [documents, setDocuments] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const { t } = useTranslation();
  const dropzoneRef = useRef();

  const fetchDocuments = async () => {
    try {
      const { data } = await api.get('/documents');
      setDocuments(data);
    } catch (err) {
      toast(t('Klaida įkeliant dokumentus'), 'error');
      console.error(err);
    }
  }

  const selectDocument = async (id) => {
    try {
      const { data } = await api.get(`/documents/${id}`);

      onDocumentSelect(data);
    } catch (err) {
      toast(t('Klaida įkeliant dokumentą'), 'error');
      console.error(err);
    }
  }

  useEffect(() => {
    fetchDocuments();
  }, []);

  const handleDrop = async (files) => {
    const file = files[0];

    const formData = new FormData();
    formData.append('file', file);

    setIsUploading(true);

    try {
      await api.post('/documents/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      toast(t('Dokumentas įkeltas'), 'success');
      await fetchDocuments();
    } catch (err) {
      toast(t('Klaida įkeliant dokumentą'), 'error');
      console.error(err);
    }

    setIsUploading(false);
    setIsCreating(false);
  };


  const prepareTableColumns = () => {
    const columns = [
      'ID',
      'Pavadinimas',
      'Tipas',
      'Dydis',
      'Sukurta',
      'Sukūrė',
    ];

    return columns;
  }

  const prepareTableData = (records) => {
    const data = _.map(records, record => {
      let row = [];

      row.push(record._id);
      row.push((
        <span
          style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
          onClick={() => selectDocument(record._id)}
        >
          {record.title}
        </span>
      ));
      row.push(record.type.toUpperCase());
      row.push(`${record.size} MB`);
      row.push(<span title={moment(record.createdAt).utc().format('YYYY-MM-DD HH:mm:ss')}>{moment(record.createdAt).utc().format('YYYY-MM-DD')}</span>);
      row.push(record.owner?.user?.fullName);

      return row;
    });

    return data;
  }

  const columns = prepareTableColumns();
  const data = prepareTableData(documents);

  return (
    <div>
      <DataTable
        title="Dokumentai"
        columns={columns}
        data={data}
        createButtonText={t('Įkelti')}
        createHandler={() => setIsCreating(true)}
      // tableHeight={window.innerHeight > 900 ? '65vh' : '45vh'}
      />

      {!!isCreating && (
        <div className="documents-create-wrapper">

          <Dropzone
            ref={dropzoneRef}
            onDrop={handleDrop}
            style={{ backgroundColor: 'red', width: '100%', height: 400 }}
            disabled={isUploading}
          >
            {({ getRootProps, getInputProps }) => (
              <div
                {...getRootProps({ className: 'dropzone' })}
                className="document-dropzone"
              >
                <input {...getInputProps()} />
                <p
                  style={{
                    color: '#ffffff',
                    textAlign: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  {!isUploading ? t('Įtempkite dokumentą arba paspauskite ant šio teksto') : t('Įkeliamas dokumentas...')}
                </p>
              </div>
            )}
          </Dropzone>

          <div className="document-create-close">
            <IconButton onClick={() => isUploading ? {} : setIsCreating(false)}>
              <CloseIcon style={{ color: 'white' }} />
            </IconButton>
          </div>
        </div >
      )}
    </div >
  );
}

export default ValueImporter;